import type { VideoProvider } from './detectVideoUrl'

export async function fetchThumbnailUrl(provider: VideoProvider, providerId: string): Promise<string | null> {
	try {
		if (provider === 'youtube') {
			return `https://img.youtube.com/vi/${providerId}/hqdefault.jpg`
		}

		if (provider === 'vimeo') {
			const res = await fetch(`https://vimeo.com/api/oembed.json?url=${encodeURIComponent(`https://vimeo.com/${providerId}`)}`)
			if (!res.ok) return null
			const data = await res.json()
			return data.thumbnail_url ?? null
		}

		if (provider === 'dailymotion') {
			const res = await fetch(`https://api.dailymotion.com/video/${providerId}?fields=thumbnail_url`)
			if (!res.ok) return null
			const data = await res.json()
			return data.thumbnail_url ?? null
		}

		return null
	} catch {
		return null
	}
}
